export default __webpack_public_path__ + "static/media/badge.670e2863.webp";